import React from "react";
import AppContainer from "../../../components/app-container/AppContainer";
import { useTranslation } from "react-i18next";

export const EasyLanguagePage = () => {
    const { t } = useTranslation();

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <div className={"dsgvo-page"}>
                    <h1>{t("SIMPLE_LANGUAGE.HEADLINE")}</h1>
                    <p>{t("SIMPLE_LANGUAGE.PREFIX")}</p>
                    <div>
                        <h2>{t("SIMPLE_LANGUAGE.HEADLINE2")}</h2>
                        <p>{t("SIMPLE_LANGUAGE.TEXT2")}</p>
                    </div>
                    <div>
                        <h2>{t("SIMPLE_LANGUAGE.HEADLINE3")}</h2>
                        <p>{t("SIMPLE_LANGUAGE.TEXT3")}</p>
                    </div>
                </div>
            </AppContainer>
        </>
    );
};
